import * as coreClient from "@azure/core-client";
import * as Parameters from "./models/parameters";
import * as Mappers from "./models/mappers";
import {
  HostOptions,
  AddressAPIOptionalParams,
  AddressSearchOptionalParams,
  AddressSearchOperationResponse,
  AddressSearchDrillDownOptionalParams,
  AddressSearchDrillDownResponse,
  AddressRetrieveOptionalParams,
  AddressRetrieveResponse
} from "./models";

export class AddressAPI extends coreClient.ServiceClient {
  $host: HostOptions;

  /**
   * Initializes a new instance of the AddressAPI class.
   * @param options The parameter options
   */
  constructor(options?: AddressAPIOptionalParams) {
    // Initializing default values for options
    if (!options) {
      options = {};
    }
    const defaults: AddressAPIOptionalParams = {
      requestContentType: "application/json; charset=utf-8"
    };

    const packageDetails = `azsdk-js-addressAPI/1.0.0-beta.1`;
    const userAgentPrefix =
      options.userAgentOptions && options.userAgentOptions.userAgentPrefix
        ? `${options.userAgentOptions.userAgentPrefix} ${packageDetails}`
        : `${packageDetails}`;

    const optionsWithDefaults = {
      ...defaults,
      ...options,
      userAgentOptions: {
        userAgentPrefix
      },
      baseUri:
        options.endpoint ??
        options.baseUri ??
        "https://dt8nxbus.api.nationalexpress.com"
    };
    super(optionsWithDefaults);

    // Assigning values to Constant parameters
    this.$host = options.$host || "https://dt8nxbus.api.nationalexpress.com";
  }

  /**
   * Address Search
   * @param options The options parameters.
   */
  addressSearch(
    options?: AddressSearchOptionalParams
  ): Promise<AddressSearchOperationResponse> {
    return this.sendOperationRequest({ options }, addressSearchOperationSpec);
  }

  /**
   * Address Search Drill Down
   * @param options The options parameters.
   */
  addressSearchDrillDown(
    options?: AddressSearchDrillDownOptionalParams
  ): Promise<AddressSearchDrillDownResponse> {
    return this.sendOperationRequest(
      { options },
      addressSearchDrillDownOperationSpec
    );
  }

  /**
   * Retrieve Address Object
   * @param options The options parameters.
   */
  addressRetrieve(
    options?: AddressRetrieveOptionalParams
  ): Promise<AddressRetrieveResponse> {
    return this.sendOperationRequest({ options }, addressRetrieveOperationSpec);
  }
}
// Operation Specifications
const serializer = coreClient.createSerializer(Mappers, /* isXml */ false);

const addressSearchOperationSpec: coreClient.OperationSpec = {
  path: "/address/V1/search",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.AddressSearchResponse
    },
    default: {
      bodyMapper: Mappers.ApiError
    }
  },
  requestBody: Parameters.body,
  urlParameters: [Parameters.$host],
  headerParameters: [Parameters.contentType, Parameters.accept],
  mediaType: "json",
  serializer
};
const addressSearchDrillDownOperationSpec: coreClient.OperationSpec = {
  path: "/address/V1/search/drilldown",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.AddressSearchResponse
    },
    default: {
      bodyMapper: Mappers.ApiError
    }
  },
  requestBody: Parameters.body1,
  urlParameters: [Parameters.$host],
  headerParameters: [Parameters.contentType, Parameters.accept],
  mediaType: "json",
  serializer
};
const addressRetrieveOperationSpec: coreClient.OperationSpec = {
  path: "/address/V1/retrieve",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.AddressResponse
    },
    default: {
      bodyMapper: Mappers.ApiError
    }
  },
  requestBody: Parameters.body2,
  urlParameters: [Parameters.$host],
  headerParameters: [Parameters.contentType, Parameters.accept],
  mediaType: "json",
  serializer
};
